import { createTheme } from '@material-ui/core/styles';

export const getMuiTheme = () =>
  createTheme({
    overrides: {
      // MuiTableCell: {
      //   root: {
      //     borderColor: '#d3d3d3'
      //   },
      //   head: {
      //     backgroundColor: '#d3d3d3',
      //     // color: 'white'
      //     // borderRight: [[1, 'solid', '#d3d3d3']]
      //     // '&:not(:last-child)': {
      //     //   borderRight: [[1, 'solid', '#c0c0c0']],
      //     // },
      //   },
      // },
      MUIDataTableHeadCell:{
        fixedHeader:{
          backgroundColor: '#d3d3d3',
        }
      }
      // MuiButton:{
      //   root: {
      //     color: "white"
      //   }
      // }
    },
  });

export const tableOptions = {
  filterType: 'dropdown',
  selectableRows: 'none',
  setTableProps: () => {
    return {
      // padding: "none",
      // material ui v4 only
      size: "small"
    };
  }
}